<template>
  <div class="opage">
    <Head />
    <div class="bannerRow">
      <div class="backgroundBox"></div>
      <div class="bannerCon">
        <!-- 联系方式与客户服务 -->
        <h1 class="sr-only">{{ $fanyi("联系方式与客户服务") }}</h1>
        <!-- 客户服务 -->
        <div class="bannerTitle">{{ $fanyi("客户服务") }}</div>
        <p class="banP">{{ $fanyi("我们能帮您什么？") }}</p>
        <div class="helpList">
          <div class="helpType">
            <div class="helpCon" @click="$fun.clickJs()">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061517555044958.svg"
                alt=""
              />
              <h3>{{ $fanyi("与我们的团队成员交谈。") }}</h3>
              <p>
                {{
                  $fanyi(
                    "我们将为您提供帮助和建议，协助您完成从中国进口的整个流程。"
                  )
                }}
              </p>
              <button>{{ $fanyi("联系代理") }}</button>
            </div>
          </div>
          <div class="helpType">
            <div class="helpCon" @click="$fun.routerToPage('/FAQ')">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260616103420766502.png"
                alt=""
              />
              <h3>{{ $fanyi("访问我们的帮助中心解决疑问。") }}</h3>
              <p>
                {{ $fanyi("查阅我们的帮助中心以找到您所需要的解答。") }}
              </p>
              <button>{{ $fanyi("进入帮助中心") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contactUs">
      <h1>{{ $fanyi("联系方式") }}</h1>
      <div class="aListOfContactDetails">
        <div class="oneContact">
          <img
            src="../../assets/foot-img/atencion-al-cliente/lian1.svg"
            alt=""
          />
          <h3>E-mail:</h3>
          <p>service@rakumart.it</p>
        </div>
      </div>
    </div>

    <div class="platformInformation">
      <h3>{{ $fanyi("中国中心") }}</h3>
      <p><b>Rakumart China</b></p>
      <p>{{ $fanyi("中国浙江省义乌市北苑街道春晗路127号2号楼3-6层") }}</p>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
$pageWidth: 1100px;

.opage {
  background-color: white;
}

.bannerRow {
  margin-bottom: 70px;
  position: relative;
  height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;

  .backgroundBox {
    background-image: url("https://span-rakumart.oss-eu-central-1.aliyuncs.com/202303/64195b9c03b94.jpg");

    width: 50%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;

    background-position: center center;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    background-repeat-x: no-repeat;
    background-repeat-y: no-repeat;
    background-size: cover;
  }

  .bannerCon {
    position: relative;
    z-index: 1;
    width: 919px;
    margin-right: 179px;
    padding: 10px;

    .bannerTitle {
      font-size: 46px;
      font-weight: 700;
      line-height: 1.2em;
      margin-bottom: 20px;
      position: relative;
      z-index: 1;
    }

    .banP {
      font-size: 19px;
      line-height: 1;
      color: #009246;
      margin-bottom: 40px;
      position: relative;
      z-index: 1;
    }

    .helpList {
      z-index: 1;
      position: relative;
      display: flex;
      justify-content: space-between;

      .helpType {
        width: 447px;
        padding: 10px;

        .helpCon {
          height: 100%;
          border-radius: 6px 6px 6px 6px;
          background-color: white;
          box-shadow: 0px 3px 4px -2px rgba(0, 0, 0, 0.18);
          transition: 0.2s;
          cursor: pointer;

          &:hover {
            box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.25);
          }

          border: solid 1px #eaeaea;
          padding: 55px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          * {
            text-align: center;
          }

          img {
            width: 47px;
            height: 47px;
            margin-bottom: 21px;
          }

          h3 {
            font-size: 22px;
            font-weight: 500;
            line-height: 1.4em;
            margin-bottom: 15px;
          }

          p {
            font-size: 16px;
            margin-bottom: 30px;
            line-height: 1.8em;
          }

          button {
            // 与设计稿「Contactar con un agente」一致：品牌色/主色 #009246，白字，圆角 12px
            box-sizing: border-box;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 270px;
            height: 60px;
            padding: 20px 40px;
            white-space: nowrap;
            font-size: 16px;
            line-height: 20px;
            font-weight: 600;
            color: #ffffff;
            background-color: #009246;
            border: none;
            border-radius: 12px;
            transition: background-color 0.3s;
            cursor: pointer;

            &:hover {
              background-color: #2a6418;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}

.contactUs {
  width: $pageWidth;
  margin: 0 auto 50px;

  h1 {
    margin-bottom: 20px;
    padding: 10px;
    font-size: 21px;
    line-height: 29px;
  }

  .aListOfContactDetails {
    display: flex;

    .oneContact {
      border-radius: 6px;
      border-style: solid;
      //flex: 1;
      flex: 0 0 366px;
      border-width: 1px 1px 1px 1px;
      border-color: #e4e4e4;
      transition: background 0.3s, border 0.3s, border-radius 0.3s,
        box-shadow 0.3s;
      margin: 0px 10px 0px 10px;
      padding: 30px 30px 30px 30px;

      img {
        width: 25px;
        height: 25px;
        margin-bottom: 15px;
      }

      h3 {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        line-height: 33px;
        margin-bottom: 14px;
      }
    }
  }
}

.platformInformation {
  width: $pageWidth;
  margin: 0 auto 20px;

  &:last-child {
    margin-bottom: 50px;
  }

  padding: 10px;

  h3 {
    font-size: 21px;
    font-weight: 500;
    line-height: 1.4em;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 0.9rem;
    font-size: 16px;
    line-height: 33px;
    margin-bottom: 14px;
  }
}
</style>
